module.exports = __webpack_public_path__ + "static/img/icon39.921c509.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon39.png
// module id = APEI
// module chunks = 1